/* ===== AROMAZUR v25 — fiche produit alimentee par la base des bulles ===== */
(function(){
  var ALIAS={'package-protection':'az-protection-aromazur'};
  var ICONS={
  flame:'<path d="M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 11-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z"/>',
  droplet:'<path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0z"/>',
  moon:'<path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>',
  sun:'<circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>',
  coffee:'<path d="M18 8h1a4 4 0 010 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8zM6 1v3M10 1v3M14 1v3"/>',
  "map-pin":'<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>',
  ruler:'<path d="M3 3h18v6H3zM7 9v3M11 9v3M15 9v3M19 9v3"/>',
  wind:'<path d="M9.59 4.59A2 2 0 1111 8H2M12.59 19.41A2 2 0 1014 16H2M17.73 7.73A2.5 2.5 0 1119.5 12H2"/>',
  "device-speaker":'<rect x="4" y="2" width="16" height="20" rx="2"/><circle cx="12" cy="14" r="4"/><circle cx="12" cy="6" r="1"/>',
  battery:'<rect x="2" y="7" width="16" height="10" rx="2"/><path d="M22 11v2"/><path d="M6 11v2M10 11v2M14 11v2"/>',
  plug:'<path d="M12 22v-5M9 8V2M15 8V2M18 8v4a6 6 0 01-12 0V8z"/>',
  gift:'<path d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>',
  truck:'<path d="M1 3h15v13H1zM16 8h4l3 3v5h-7M5.5 18.5a2 2 0 100 1M18.5 18.5a2 2 0 100 1"/>'
};
  function icon(n){ return '<svg viewBox="0 0 24 24">'+(ICONS[n]||ICONS['droplet'])+'</svg>'; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  function intensite(n){
    var b=''; for(var i=1;i<=5;i++) b+='<div class="int-bar'+(i<=n?' on':'')+'"></div>';
    var lab=['','Très léger','Léger','Modéré','Intense','Très intense'];
    return '<div class="intensity"><span class="int-label">Intensité</span><div class="int-bars">'+b+
           '</div><span class="int-txt">'+(lab[n]||'')+'</span></div>';
  }

  /* si la description Shopify contient deja un tableau de caracteristiques,
     on n'affiche pas celui de la base : pas de doublon */
  function dejaDecrit(){
    var d=document.querySelector('.pp-desc');
    return !!(d && d.querySelector('table'));
  }
  function bloc(titre, contenu){
    return '<section class="pdp-bloc"><h3>'+esc(titre)+'</h3>'+contenu+'</section>';
  }

  function panneaux(p){
    var T=[];

    /* 1 — Description */
    var d='';
    if(p.highlights){
      var h=p.highlights, l='';
      (h.points||[]).forEach(function(pt){
        l+='<div class="hl-item"><div class="hl-ic">'+icon(pt.icon)+'</div><div class="hl-txt">'+esc(pt.txt)+'</div></div>';
      });
      d=(h.accroche?'<p class="hl-accroche">'+esc(h.accroche)+'</p>':'')+
        (h.intro?'<p class="hl-intro">'+esc(h.intro)+'</p>':'')+
        (l?'<div class="hl-list">'+l+'</div>':'');
    } else if(p.body){ d=p.body; }
    if(d) T.push({t:'Description', c:d});

    /* 2 — Pyramide olfactive OU Caracteristiques */
    if(p.pyramid){
      var y=p.pyramid;
      T.push({t:'Pyramide olfactive', c:
        '<div class="pyramid">'+
        '<div class="pyr-row"><span class="pyr-label">Tête</span><span class="pyr-notes">'+esc(y.tete)+'</span></div>'+
        '<div class="pyr-row"><span class="pyr-label">Cœur</span><span class="pyr-notes">'+esc(y.coeur)+'</span></div>'+
        '<div class="pyr-row"><span class="pyr-label">Fond</span><span class="pyr-notes">'+esc(y.fond)+'</span></div>'+
        '</div>'+intensite(y.intensite)+
        '<div class="attrs"><span class="attr-chip"><b>'+esc(y.ambiance)+'</b></span>'+
        '<span class="attr-chip">'+esc(y.moment)+'</span><span class="attr-chip">'+esc(y.genre)+'</span></div>'});
    } else if(p.specs){
      var s=p.specs, g='';
      [['Couverture',s.couverture],['Type',s.type],['Compatibilité',s.compat],['Alimentation',s.autonomie]]
        .forEach(function(kv){ if(kv[1]) g+='<div class="spec-item"><div class="k">'+kv[0]+'</div><div class="v">'+esc(kv[1])+'</div></div>'; });
      if(s.usage) g+='<div class="spec-item spec-wide"><div class="k">Idéal pour</div><div class="v">'+esc(s.usage)+'</div></div>';
      T.push({t:'Caractéristiques', c:'<div class="specs-grid">'+g+'</div>'});
    }

    /* 3 — Conseils */
    if(p.pyramid){
      var y2=p.pyramid;
      T.push({t:'Conseils', c:
        '<p><b>Comment l\'utiliser :</b> versez quelques gouttes dans votre diffuseur AROMAZUR. '+
        'La nébulisation à froid préserve l\'intégrité du parfum pour une diffusion pure et durable.</p>'+
        '<p><b>Ambiance recommandée :</b> '+esc(String(y2.ambiance).toLowerCase())+', idéal en '+esc(String(y2.moment).toLowerCase())+'.</p>'+
        '<p><b>Quel format choisir ?</b> Tous nos formats sont compatibles avec tous nos diffuseurs : '+
        'un flacon de 20 ml se transvase dans le réservoir de n\'importe quel appareil. '+
        'Comptez environ deux semaines de diffusion pour le 20 ml, un mois pour le 50 ml, '+
        'deux mois pour le 120 ml et jusqu\'à six mois pour le 500 ml.</p>'});
    } else if(p.specs){
      T.push({t:'Conseils', c:
        '<p><b>Installation :</b> '+esc(p.specs.usage||'placez le diffuseur dans la pièce souhaitée')+'.</p>'+
        '<p><b>Quel format d\'huile ?</b> Tous nos formats fonctionnent avec tous nos diffuseurs. '+
        'Un flacon de 20 ml se transvase simplement dans le réservoir de l\'appareil — inutile qu\'il soit '+
        'au format du flacon d\'origine. Le 20 ml tient environ deux semaines, le 50 ml un mois, '+
        'le 120 ml deux mois et le 500 ml jusqu\'à six mois.</p>'+
        '<p><b>Entretien :</b> aucun produit nécessaire — le changement de flacon suffit.</p>'});
    }

    /* 4 — Livraison */
    T.push({t:'Livraison', c:
      '<p><b>✦ Point relais offert</b> dès 49 € d\'achat en France métropolitaine. Livraison à domicile à partir de 7,99 € selon le poids.</p>'+
      '<p>Expédition sous 3 à 5 jours ouvrés. Suivi de commande fourni.</p>'+
      '<p><b>Retours :</b> 30 jours satisfait ou remboursé (le délai légal est de 14 jours, nous allons au-delà).</p>'+
      '<p><b>Paiement sécurisé</b> : CB, Apple Pay, Google Pay, PayPal.</p>'});

    return T;
  }

  function rendu(p){
    var T=panneaux(p);
    if(!T.length) return '';
    var nav='', pan='';
    T.forEach(function(x,i){
      nav+='<button type="button" class="pdp-tab'+(i===0?' on':'')+'" data-i="'+i+'">'+esc(x.t)+'</button>';
      pan+='<div class="pdp-panel'+(i===0?' on':'')+'" data-i="'+i+'">'+x.c+'</div>';
    });
    return '<div class="pdp-tabs">'+nav+'</div><div class="pdp-panels">'+pan+'</div>';
  }

  function brancherOnglets(racine){
    racine.addEventListener('click',function(e){
      var b=e.target.closest?e.target.closest('.pdp-tab'):null;
      if(!b) return;
      var i=b.getAttribute('data-i');
      racine.querySelectorAll('.pdp-tab').forEach(function(x){x.classList.toggle('on',x===b);});
      racine.querySelectorAll('.pdp-panel').forEach(function(x){x.classList.toggle('on',x.getAttribute('data-i')===i);});
    });
  }


  /* ================= ELEMENTS DE VENTE (inspires des meilleures fiches du secteur) ============ */
  var REV={}; (function(){ for(var k in ALIAS) REV[ALIAS[k]]=k; })();
  function urlProduit(h){
    var s=REV[h] || (h.indexOf('az-')===0 ? h.slice(3) : h);
    return '/products/'+s;
  }
  function prixMini(p){
    var v=(p.variants&&p.variants[0])?p.variants[0].price:null;
    return (typeof v==='number')?v:null;
  }
  function eur2(n){ return n.toFixed(2).replace('.',',')+' €'; }

  /* --- fil d'Ariane --- */
  /* Points cles (couverture, sans fil, flacon...) sous le prix : 4 maximum. */
  function faitsCles(p, info){
    var pts=(p.highlights&&p.highlights.points)||[]; if(!pts.length) return;
    var prix=document.getElementById('ppPrice'); if(!prix) return;
    var ul=document.createElement('ul'); ul.className='pp-facts';
    pts.slice(0,4).forEach(function(pt){
      var li=document.createElement('li'); li.innerHTML='<span class="pp-fact-ic">'+icon(pt.icon)+'</span>'+esc(pt.txt); ul.appendChild(li);
    });
    prix.parentNode.insertBefore(ul, prix.nextSibling);
    /* la meme liste n'est pas repetee dans l'onglet Description */
    var dbl=info.querySelector('.pdp-rich .hl-list'); if(dbl) dbl.remove();
  }
  function filAriane(p){
    var cat = p.type==='huile' ? ['Huiles parfumées','/collections/huiles-parfumees']
            : p.type==='diffuseur' ? ['Diffuseurs','/collections/diffuseurs']
            : p.type==='pack' ? ['Packs','/collections/packs']
            : ['Coffrets','/collections/coffrets'];
    var n=document.createElement('nav'); n.className='pdp-crumb';
    n.innerHTML='<a href="/">Accueil</a> <span>/</span> <a href="'+cat[1]+'">'+cat[0]+'</a> <span>/</span> <em>'+esc(p.title)+'</em>';
    var w=document.querySelector('.product-page .wrap'), b=document.querySelector('.back-link');
    if(w) w.insertBefore(n, b?b.nextSibling:w.firstChild);
  }

  /* --- badge d'economie a cote du prix --- */
  function badgeEconomie(){
    var box=document.getElementById('ppPrice'); if(!box) return;
    function maj(){
      var o=box.querySelector('.az-old'), n=box.querySelector('.az-new');
      if(!o||!n) return;
      var a=parseFloat(o.textContent.replace(/[^\d,]/g,'').replace(',','.'));
      var b=parseFloat(n.textContent.replace(/[^\d,]/g,'').replace(',','.'));
      if(!a||!b||b>=a) return;
      var pct=Math.round((1-b/a)*100);
      var txt='ÉCONOMISEZ '+pct+' %';
      var e=box.querySelector('.az-save');
      if(e && e.textContent===txt) return;      /* rien a changer : on ne touche pas au DOM */
      /* On coupe l'observateur PENDANT la modification. Sans cela, ecrire le
         badge dans #ppPrice declenche l'observateur, qui reecrit le badge, qui
         redeclenche l'observateur : la page se fige des le premier changement
         de format. C'est ce qui bloquait les boutons 50 / 120 / 500 ml. */
      obs.disconnect();
      if(!e){ e=document.createElement('span'); e.className='az-save'; box.appendChild(e); }
      e.textContent=txt;
      obs.observe(box,{childList:true,subtree:true});
    }
    var obs=new MutationObserver(maj);
    maj();
    obs.observe(box,{childList:true,subtree:true});
  }

  /* --- bandeau de reassurance defilant --- */
  function bandeau(){
    var m=['Façonné à Grasse','Sans eau ni chaleur','Sans danger pour enfants et animaux',
           'Nébulisation à froid','Point relais offert dès 49 €','Paiement sécurisé'];
    var d=document.createElement('div'); d.className='pdp-marquee';
    var s=m.map(function(x){return '<span>'+esc(x)+'</span>';}).join('');
    d.innerHTML='<div class="pdp-marquee-in">'+s+s+'</div>';
    var g=document.querySelector('.pp-grid');
    if(g&&g.parentNode) g.parentNode.insertBefore(d, g.nextSibling);
  }

  /* --- barre d'achat collante en bas --- */
  function barreCollante(p){
    var form=document.getElementById('ppForm'); if(!form) return;
    var b=document.createElement('div'); b.className='pdp-sticky';
    b.innerHTML='<div class="ps-in">'+
      (p.images&&p.images[0]?'<img src="'+esc(p.images[0])+'" alt="">':'')+
      '<div class="ps-txt"><strong>'+esc(p.title)+'</strong><span class="ps-price"></span></div>'+
      '<button type="button" class="ps-add">Ajouter au panier</button></div>';
    document.body.appendChild(b);
    b.querySelector('.ps-add').addEventListener('click',function(){
      /* si le bloc « Choisissez votre formule » est present, c'est LUI qui commande :
         le formulaire natif est masque et n'alimente pas le meme panier */
      var offres=document.querySelector('.az-offres');
      if(offres){
        offres.scrollIntoView({behavior:'smooth',block:'center'});
        var bt=document.getElementById('azOffreAdd'); if(bt) bt.click();
        return;
      }
      form.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true}));
      window.scrollTo({top:0,behavior:'smooth'});
    });
    var px=document.getElementById('ppPrice'), out=b.querySelector('.ps-price');
    function sync(){ if(px&&out) out.innerHTML=px.innerHTML; }
    sync(); if(px) new MutationObserver(sync).observe(px,{childList:true,subtree:true});
    function onScroll(){
      var r=form.getBoundingClientRect();
      b.classList.toggle('on', r.bottom<0);
    }
    document.body.classList.add('has-sticky');
  /* getBoundingClientRect() a chaque evenement de defilement forcait un recalcul
     de mise en page plusieurs dizaines de fois par seconde, pour un booleen. */
  var tick=false;
  window.addEventListener('scroll',function(){
    if(tick)return; tick=true;
    requestAnimationFrame(function(){ onScroll(); tick=false; });
  },{passive:true}); onScroll();
  }

  /* --- produits associes --- */
  function carte(p){
    var pr=prixMini(p);
    return '<a class="pdp-card" href="'+urlProduit(p.handle)+'">'+
      (p.images&&p.images[0]?'<span class="pc-img"><img src="'+esc(p.images[0])+'" alt="" loading="lazy"></span>':'')+
      '<span class="pc-t">'+esc(p.title)+'</span>'+
      (p.family?'<span class="pc-f">'+esc(p.family)+'</span>':'')+
      (pr!=null?'<span class="pc-p">'+eur2(pr)+'</span>':'')+'</a>';
  }
  function grille(titre, liste){
    if(!liste.length) return '';
    return '<section class="pdp-reco"><h3>'+esc(titre)+'</h3><div class="pdp-reco-grid">'+
      liste.map(carte).join('')+'</div></section>';
  }
  function associes(p){
    var DB=window.AZ_DB, tous=Object.keys(DB).map(function(k){return DB[k];})
      .filter(function(x){ return x.handle!==p.handle && !/abonnement|protection/i.test(x.handle); });
    var html='';
    if(p.type==='diffuseur'||p.type==='pack'){
      var huiles=tous.filter(function(x){return x.type==='huile';}).slice(0,4);
      html+=grille('Complétez avec nos huiles', huiles);
      var autres=tous.filter(function(x){return x.type==='diffuseur';}).slice(0,4);
      html+=grille('Autres diffuseurs de la gamme', autres);
    } else {
      var meme=tous.filter(function(x){return x.type==='huile' && x.family===p.family;}).slice(0,4);
      if(meme.length<4) meme=meme.concat(tous.filter(function(x){return x.type==='huile'&&meme.indexOf(x)<0;}).slice(0,4-meme.length));
      html+=grille('Dans la même famille olfactive', meme);
      html+=grille('Diffuseurs compatibles', tous.filter(function(x){return x.type==='diffuseur';}).slice(0,4));
    }
    if(!html) return;
    var d=document.createElement('div'); d.className='pdp-recos'; d.innerHTML=html;
    /* les blocs de recommandation passent AVANT le texte long :
       les onglets couvrent deja les caracteristiques */
    var host=document.querySelector('.pp-below');
    if(host&&host.parentNode) host.parentNode.insertBefore(d, host);
    if(window.AZ_PROMO_REF) try{ AZ_PROMO_REF.cartes(); }catch(e){}
  }

  function boot(){
    var DB=window.AZ_DB; if(!DB) return;
    var sh=window.AZ_PRODUCT_HANDLE||''; if(!sh) return;
    var p=DB[ALIAS[sh]||('az-'+sh)] || DB[sh];
    if(!p) return;
    if(window.AZ_I18N && AZ_I18N.patchDB){ try{ AZ_I18N.patchDB(DB); }catch(e){} }
    var info=document.querySelector('.pp-info');
    var form=document.getElementById('ppForm');
    if(!info||!form) return;
    var d=document.createElement('div'); d.className='pdp-rich';
    d.innerHTML=rendu(p);
    if(!d.innerHTML) return;
    /* Fiche restructuree (08/09/2026) : l'achat d'abord. Les onglets
       (description, caracteristiques, conseils, livraison) passent SOUS le
       bloc d'achat et la reassurance ; les points cles du produit remontent
       en une ligne sous le prix pour que le choix se fasse sans defiler. */
    var reassure=info.querySelector('.pp-reassure');
    if(reassure) info.insertBefore(d, reassure.nextSibling); else info.appendChild(d);
    faitsCles(p, info);
    brancherOnglets(d);
    var fam=document.querySelector('.pp-type');
    if(fam && p.family){ fam.textContent=p.family.toUpperCase(); if(p.famhex) fam.style.color=p.famhex; }
    try{ filAriane(p); badgeEconomie(); bandeau(); barreCollante(p); associes(p); }catch(e){}
    if(p.notes){
      var n=document.createElement('div'); n.className='pp-notes';
      n.textContent='Notes olfactives : '+p.notes;
      var h1=document.querySelector('.pp-info h1');
      if(h1) h1.parentNode.insertBefore(n, h1.nextSibling);
      if(p.inspire||p.univers){ var u=document.createElement('div'); u.className='pp-univers'; if(p.inspire){ u.innerHTML='Inspiré par : <b></b>'; u.querySelector('b').textContent=p.inspire; } else u.textContent=p.univers; n.parentNode.insertBefore(u, n.nextSibling); }
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
